// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__9EVOt","form":"EditProfile_form__AsVVE","userImage":"EditProfile_userImage__S+Z7c"};